import type { FC, ReactElement } from 'react';

import { Modal } from '../../modal/modal/Modal';
import type { ChatModalProps } from '../types';

export const ChatModal: FC<ChatModalProps> = ({ children, isChatModalOpen, onClose, title, ...rest }): ReactElement => (
  <Modal
    data-testid="chat-modal"
    draggable
    grow
    limitedHeight="var(--core-chat-limited-modal-height)"
    onClose={onClose}
    open={isChatModalOpen}
    originX="end"
    tk={title}
    {...rest}
  >
    {children}
  </Modal>
);
